/**
 * 访问数据
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>访问数据</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="来源：">
        <el-select size="small" v-model="formInline.source" placeholder="全部">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="chatID：">
        <el-input size="small" v-model="formInline.source_id" placeholder="输入chatID"></el-input>
      </el-form-item>
      <el-form-item label="日期：">
          <el-date-picker
          v-model="formInline.daterange"
          @change="handleDateChange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          >
        </el-date-picker>
      </el-form-item>
     
     
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleadd1()">新建</el-button> -->
        <el-button size="small" type="primary" @click="handleunit()">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" width="60" label="序号">
      </el-table-column>
      <el-table-column  prop="input" label="输入" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  prop="file" label="附件" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="output" label="输出" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="source" label="来源" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="source_id" label="ID" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="created_at" label="时间" width="180" show-overflow-tooltip>
        <!-- <template slot-scope="scope">
          <div>{{scope.row.time|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">预览</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="输入" style="color: #333;">
            </el-form-item>
            <div class="chatsz_contactssss"  v-html="editForm.input">
            </div>
            <el-form-item label="输出" style="color: #333;">
            </el-form-item>
            <div class="chatsz_contactssss"  v-html="editForm.output"></div>
            <!-- <el-form-item label="联系搜索" style="color: #333;">
            </el-form-item>
            <div class="chatsz_contactssss"  v-html="editForm.output"></div> -->
           
          </el-col>
        </el-row>
        
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { questList, questGet, questExport } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      payType: [
        { key: '全部', value: 'null' },
        { key: 'chatWEB', value: 'chatWEB' },
        { key: 'chatBOT', value: 'chatBOT' },
        { key: 'chatAPI', value: 'chatAPI' },
      ],
      editForm: {
        
      },
      formInline: {
        page: 1,
        page_size: 10,
        // source: '',
        // source_id: '',
         status:'success',
        // created_at_start:'',
        // created_at_end:'',
        // daterange:''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        userMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //显示编辑界面
       //显示编辑界面
       handleadd: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改用户'
        this.editForm.userId = row.userId
        this.editForm.userName = row.userName
        this.editForm.userRealName = row.userRealName
        this.editForm.roleId = row.roleId
        this.editForm.userMobile = row.userMobile
        this.editForm.userEmail = row.userEmail
        this.editForm.userSex = row.userSex
      } else {
        this.title = '详情'
        this.editForm.userId = ''
        this.editForm.userName = ''
        this.editForm.userRealName = ''
        this.editForm.roleId = ''
        this.editForm.userMobile = ''
        this.editForm.userEmail = ''
        this.editForm.userSex = ''
      }
    },
    handleDateChange(dates) {
    if (dates && dates.length === 2) {
      // created_at_start:'',
        // created_at_end:'',
        // daterange:''
      this.formInline.created_at_start =dates[0];
      this.formInline.created_at_end =dates[1];
    }
  },
  handleunit(){
      if(this.formInline.source=='null'){
        //删除parameter.status参数
        delete this.formInline.source;
      }
     // return;
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       questExport(this.formInline)
        .then(res => {
          this.loading = false
          console.log(res,'1111111111111111111')
          // res是Excel文件流，实现下载Excel
          // const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          // const url = window.URL.createObjectURL(blob);
          // const link = document.createElement('a');
          // link.href = url;
          // link.download = '访问数据.xlsx';
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // window.URL.revokeObjectURL(url);
            // 1. 创建 Blob 对象（重点：指定 Excel 的 MIME 类型）
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Excel MIME 类型
          });
          // 2. 创建临时 URL
          const url = window.URL.createObjectURL(blob);

          // 3. 创建隐藏的 <a> 标签并触发下载
          const link = document.createElement('a');
          link.href = url;
          
          // 获取文件名（从响应头或自定义）
         const fileName = this.getFileName(res) || 'download.xlsx';
        //  console.log(fileName,22222222);
          link.download = fileName; // 设置下载文件名

          // 4. 触发点击（兼容写法）
          document.body.appendChild(link);
          link.click();
          
          // 5. 清理临时对象
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        downloadExcel(res);
          })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
  },
    getFileName(res) {
    const disposition = res.headers['content-disposition'];
    if (disposition) {
      const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = fileNameRegex.exec(disposition);
      if (matches && matches[1]) {
        return matches[1].replace(/['"]/g, '');
      }
    }
    return null;
  },

    // 列表
    getdata(parameter) {
      console.log(parameter,111111111111)
      if(parameter.source=='null'){
        //删除parameter.status参数
        delete parameter.source;
      }
     // return;
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       questList(parameter)
        .then(res => {
          this.loading = false
          console.log(res,333333333333333)
          if (res.message == "success") {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.currentPage = res.data.page_info.page
            this.pageparm.pageSize = res.data.page_info.page_size
             this.pageparm.total = res.data.page_info.total
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm,999)
      this.formInline.page = parm.currentPage
      this.formInline.page_size = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
      // console.log(row.id,'detail')
      questGet(row.id)
        .then(res => {
          this.loading = false
          console.log(res,'detail')
          if (res.message == "success") {
            this.editForm = res.data;
            // console.log(this.editForm,'detail')
            // 分页赋值
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.chatsz_contactssss{
  margin:0 120px;
  margin-bottom: 40px;
  white-space: pre-wrap;
}
/deep/ .el-form-item__label{
  color: #000 !important;
  font-size: 16px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/data/data.vue